import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type AIFollowUpClientRepliedConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
	customIcon?: JSX.Element
}

const AIFollowUpClientRepliedConditionSection: React.FC<AIFollowUpClientRepliedConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text,
		customIcon
	} = props

	const clientRepliedCondition = getConditionByValidationSlug("ai-follow-up-client-replied", nextChatBotFlowBlockRules)

	if (!clientRepliedCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={clientRepliedCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={customIcon || <ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default AIFollowUpClientRepliedConditionSection
